import { render, staticRenderFns } from "./IntroVideo.vue?vue&type=template&id=5283ac1f&scoped=true&"
import script from "./IntroVideo.vue?vue&type=script&lang=js&"
export * from "./IntroVideo.vue?vue&type=script&lang=js&"
import style0 from "./IntroVideo.vue?vue&type=style&index=0&id=5283ac1f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5283ac1f",
  null
  
)

component.options.__file = "src/components/IntroVideo.vue"
export default component.exports